import { useDispatch, useSelector } from 'react-redux';
import { compose } from 'recompose';

import withAcls from '~/common/hoc/withAcls';
import withHooks from '~/common/hoc/withHooks';

const enhancer = compose(
  withAcls,
  withHooks(props => {
    const { application, realms, license } = useSelector(state => state);
    const dispatch = useDispatch();
    const state = {
      realm: application.realm.realm,
      realmData: realms.getRealm,
      license: license.license,
      hasCustomerIdentityProvider: application.hasCustomerIdentityProvider
    };
    const actions = {
      onPressBack: isTargetBlank => {
        const path = `/${state.realm}/operation/build/pipelines`;

        if (isTargetBlank) return window.open(path, '_blank');

        return dispatch.router.navigate({ to: path });
      }
    };

    return {
      ...props,
      ...state,
      ...actions
    };
  })
);

export default enhancer;
